import React, { useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import ProjectCard from './ProjectCards'
import Reveal from '../Reveal'
import ScrambleText from '../ScrambleText'

const projects = [
  {
    title: 'Manufex',
    category: 'IoT',
    description: 'A large-scale factory monitoring system for Maini Industries that collects real-time data from multiple CNC machines using OPC server and IoT gateway devices, stores it on AWS cloud and displays live dashboards via AWS QuickSight.',
    tags: ['AWS QuickSight', 'OPC Server', 'IoT', 'CNC', 'Real-time'],
    link: 'https://github.com/Amaan-AeonX',
  },
  {
    title: 'Konark Vision',
    category: 'Vision',
    description: 'Automated model training, production and inventory management system for Konark Industries. Developed through devices such as Raspberry Pi and Machine Vision cameras for real-time production tracking.',
    tags: ['Raspberry Pi', 'Computer Vision', 'Automation', 'Inventory'],
    link: 'https://github.com/Amaan-AeonX',
  },
  {
    title: 'Vision Manufex — Sunder Industries',
    category: 'Vision',
    description: 'A multi-tenant, fully automated machine vision SaaS application for Sunder Industries enabling real-time inventory tracking. Leverages IoT gateways, PLCs, industrial sensors and vision cameras with seamless end-to-end cloud integration.',
    tags: ['SaaS', 'Machine Vision', 'IoT', 'PLC', 'GCP', 'Multi-tenant'],
    link: 'https://github.com/Amaan-AeonX',
  },
  {
    title: 'Audio Spectrum AI',
    category: 'ML',
    description: 'An AI ML model developed for audio and spectrum analysis during training at Innovative Engineers. Handles signal processing and pattern recognition across audio frequency data.',
    tags: ['Machine Learning', 'Audio Analysis', 'Signal Processing', 'Python'],
    link: 'https://github.com/Amaan-AeonX',
  },
]

// To add a demo video to any project, drop an mp4 in public/videos/ and set
// `video: '/videos/<name>.mp4'` on the entry above. Hover previews it; click opens a player.
const categories = ['All', 'IoT', 'Vision', 'ML']

function Projects() {
  const [filter, setFilter] = useState('All')
  const shown = projects.filter(p => filter === 'All' || p.category === filter)
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])

  return (
    <div style={{ paddingTop: '100px', background: 'var(--bg)', minHeight: '100vh' }}>
      <div className="section">
        <div className="section-inner">
          <ScrambleText as="h1" className="pinboard-heading" text="Pinned to the board" />
          <div className="filter-chips">
            {categories.map(c => (
              <button key={c} className={`filter-chip ${filter === c ? 'active' : ''}`} onClick={() => setFilter(c)}>
                {c}
              </button>
            ))}
          </div>
          <div className="pinboard">
            <div className="pinboard-grid">
              {shown.map((p, i) => (
                <Reveal key={p.title} delay={(i % 3) * 120}>
                  <ProjectCard {...p} />
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Projects
